import { render, staticRenderFns } from "./OtherDocDetail.vue?vue&type=template&id=2e530330&scoped=true&"
import script from "./OtherDocDetail.vue?vue&type=script&lang=js&"
export * from "./OtherDocDetail.vue?vue&type=script&lang=js&"
import style0 from "./OtherDocDetail.vue?vue&type=style&index=0&id=2e530330&scoped=true&lang=css&"
import style1 from "./OtherDocDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e530330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VContainer,VNavigationDrawer})
